import { useCallback } from "react";
import useToast from "~/components/ui/toast";

/** Copies a value and toasts the outcome. `label` names what was copied, in
 *  sentence case ("Agent ID"). */
export const useCopyToClipboard = () => {
  const { showSuccess, showError } = useToast();

  return useCallback(
    async (value: string, label: string) => {
      try {
        await navigator.clipboard.writeText(value);
        showSuccess(`${label} copied`);
      } catch {
        showError(`Failed to copy ${label}`);
      }
    },
    [showSuccess, showError]
  );
};
